"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.golf = exports.eids = void 0;
var _golfToEid = _interopRequireDefault(require("golf-to-eid"));
//
// Golf translation ids
//
const golf = {
  callUs: 'Shared:UtilityBar:SupportPhone:CallUs',
  help: 'Shared:Help',
  myAccount: 'Sales:Footer:MyAccount:ManageYourAccount',
  mainMenu: 'Shared:MobileNav:MainMenu'
};

//
// Generate Traffic2 eid's to be used to track clicks. Map the generated
// strings back to the same keys the Golf translations strings have.
// These links appear in both app and sales header thus, the prefix can be
// hard-coded as `uxp.hyd.mobile_nav`
//
exports.golf = golf;
const golfKeys = Object.keys(golf);
const eidStrings = (0, _golfToEid.default)(golfKeys.map(key => golf[key]), {
  prefix: 'uxp.hyd.mobile_nav',
  postfix: 'link.click'
});
const eids = golfKeys.reduce((eid, key, index) => {
  eid[key] = eidStrings[index];
  return eid;
}, {});
exports.eids = eids;